import React from 'react';

interface DropdownSelectorProps {
  label: string;
  options: string[] | Record<string, string>;
  value: string;
  onChange: (value: string) => void;
}

const DropdownSelector: React.FC<DropdownSelectorProps> = ({ label, options, value, onChange }) => (
  <div className="dropdownSelector">
    <label>{label}</label>
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {
        Array.isArray(options) ?
        (
          options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))
        ) : (
          Object.entries(options).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))
        )
      }
    </select>
  </div>
);

export default DropdownSelector;
